import { cx } from './ui';

/**
 * Foto de perfil, con iniciales cuando no hay foto.
 *
 * Las iniciales no son un relleno: en una lista o en el header son lo que
 * permite reconocer de un vistazo que la sesión abierta es la propia. Un ícono
 * genérico de persona se ve igual para todo el mundo.
 */
export function Avatar({
  name,
  src,
  size = 32,
  className,
}: {
  name: string | null | undefined;
  src?: string | null;
  size?: number;
  className?: string;
}) {
  const initials = (name ?? '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');

  return (
    <span
      className={cx(
        'inline-grid place-items-center rounded-full overflow-hidden shrink-0',
        'bg-primary-soft text-primary font-semibold select-none',
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
      aria-hidden
    >
      {src ? <img src={src} alt="" className="size-full object-cover" /> : (initials || '?')}
    </span>
  );
}
